export default __webpack_public_path__ + "mini-pause-button.svg";